import type { ContactPerson } from './source';

/**
 * The people on a customer or supplier as the database keeps them (db/042, #30):
 * trimmed, blank rows dropped, a name needed, an email to tick for invoices or statements.
 * Returns the list, or the same message the database would give.
 */
export function cleanPeople(list: ContactPerson[]): { people: ContactPerson[] } | { problem: string } {
  const out: ContactPerson[] = [];
  for (const p of list) {
    const name = p.name?.trim() ?? '', title = p.title?.trim() ?? '', phone = p.phone?.trim() ?? '';
    const email = p.email?.trim().toLowerCase() ?? '';
    const inv = !!p.gets_invoices, stmt = !!p.gets_statements;
    if (!name && !title && !phone && !email) continue;
    if (!name) return { problem: `Give each contact person a name (${email || phone || title})` };
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return { problem: `${name}’s email address doesn’t look right: ${email}` };
    if ((inv || stmt) && !email) {
      return { problem: `Give ${name} an email address to send them ${inv && stmt ? 'invoices and statements' : inv ? 'invoices' : 'statements'}` };
    }
    out.push({ name, ...(title && { title }), ...(phone && { phone }), ...(email && { email }), gets_invoices: inv, gets_statements: stmt });
  }
  if (out.length > 20) return { problem: 'At most 20 contact people' };
  return { people: out };
}
